import { useLazyQuery } from '@apollo/client';
import { useEffect, useState } from 'react';
import { oAuthProvidersQuery, } from 'apis/partnerIntegrations';
/** A hook to retrieve OAuth providers. */
export const useLazyReadOAuthProvider = () => {
    const [provider, setProvider] = useState();
    const [readOAuthProvider, { data: oAuthProviderData, loading: isOAuthProviderLoading, error: oAuthProviderError, },] = useLazyQuery(oAuthProvidersQuery);
    useEffect(() => {
        if (!isOAuthProviderLoading && oAuthProviderData) {
            const newProvider = oAuthProviderData.Management.oAuthProviders[0];
            setProvider(newProvider);
        }
    }, [oAuthProviderData, isOAuthProviderLoading]);
    return {
        oAuthProvider: provider,
        isOAuthProviderLoading,
        isOAuthProviderError: !!oAuthProviderError,
        readOAuthProvider,
        setOAuthProvider: setProvider,
    };
};
